'use client';

import React from 'react';
import { VStack, HStack } from '@skin-seoul/design-system';
import FavoriteButton from './FavoriteButton';
import AddToBagButton from './AddToBagButton';
import BuyNowButton from './BuyNowButton';
interface ActionButtonGroupProps {
  onAddToBag: () => void;
  onBuyNow: () => void;
  sku: string;
  size?: 'mobile' | 'desktop';
  showBuyNow?: boolean;
  productStatus?: string;
  addToBagStatus?: string;
  hasSelectedOption: boolean;
  onWishlistToggle?: (action: 'add' | 'remove') => void;
}
const ActionButtonGroup = ({
  onAddToBag,
  onBuyNow,
  sku,
  size = 'desktop',
  showBuyNow = true,
  productStatus,
  addToBagStatus,
  hasSelectedOption,
  onWishlistToggle
}: ActionButtonGroupProps) => {
  return <VStack gap={2} width="100%" data-sentry-element="VStack" data-sentry-component="ActionButtonGroup" data-sentry-source-file="ActionButtonGroup.tsx">
      <HStack gap={2} width="100%" data-sentry-element="HStack" data-sentry-source-file="ActionButtonGroup.tsx">
        <FavoriteButton sku={sku} size={size} onToggle={onWishlistToggle} data-sentry-element="FavoriteButton" data-sentry-source-file="ActionButtonGroup.tsx" />
        <AddToBagButton onClick={onAddToBag} size={size} productStatus={productStatus} addToBagStatus={addToBagStatus} hasSelectedOption={hasSelectedOption} data-sentry-element="AddToBagButton" data-sentry-source-file="ActionButtonGroup.tsx" />
      </HStack>

      {showBuyNow && <BuyNowButton onClick={onBuyNow} size={size} productStatus={productStatus} hasSelectedOption={hasSelectedOption} />}
    </VStack>;
};
export default ActionButtonGroup;